import styled from 'styled-components';

export const EditBoosterFormContainer = styled.div`
  .connected-to-row {
    display: flex;
    align-items: center;
  }

  .pipe {
    height: 2px;
    background-color: ${({ theme: { token } }) => token.colorBorder};
  }

  .widget {
    z-index: 1;
  }

  .divider {
    margin: ${({ theme: { token } }) => token.margin}px 0;
  }
`;
